import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { actions } from './state/actions';

import { Filter, Main } from '../../containers';
import { SitePicker } from './components/SitePicker';
import { StudentGrid } from './components/StudentGrid';
import { ReportGeneration } from 'Common/ObjectHelper';

class ProhibitedItemsContainer extends Component {
  componentDidUpdate(prevProps) {
    const { report } = this.props;

    if (report.data && !prevProps.report.data) {
      ReportGeneration(report.data, 'ProhibitedItems');
      this.props.clearReport();
    }
  }

  gridFunctions = {
    toggleCheckAll: this.props.toggleCheckAll,
    toggleStudentChecked: this.props.toggleStudentChecked,
  };

  getMainProps = () => {
    const {
      report,
      page: { students },
    } = this.props;
    const { loading } = report;
    const disabled = loading || !students.some(s => s.Checked);

    return {
      toolbox: {
        rightButtons: [
          {
            content: 'View',
            onClick: this.props.generateReport,
            loading,
            disabled,
          },
        ],
        shown: true,
      },
    };
  };

  render() {
    const { page, getStudents } = this.props;
    const { students, loading } = page;
    const gridProps = { students, loading };

    return (
      <Fragment>
        <Filter title={'Prohibited Items'}>
          <SitePicker onChange={getStudents} />
        </Filter>
        <Main {...this.getMainProps()}>
          <StudentGrid {...gridProps} {...this.gridFunctions} />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ ProhibitedItemsState }) => {
  return { ...ProhibitedItemsState };
};

export const ProhibitedItems = withRouter(
  connect(
    mapStateToProps,
    actions
  )(ProhibitedItemsContainer)
);



// WEBPACK FOOTER //
// ./src/pages/prohibiteditems/ProhibitedItems.js